import { render, staticRenderFns } from "./CkEditorBlock.vue?vue&type=template&id=66335535&lang=pug&"
import script from "./CkEditorBlock.vue?vue&type=script&lang=ts&"
export * from "./CkEditorBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports